import styles from 'js/components/data_sources/add_ds_form/SyslogConfiguration/SyslogConfiguration.module.scss';
import React from 'react';
import CopyButton from 'js/components/data_sources/add_ds_form/SyslogConfiguration/SyslogCopyButton';

type PropsType = {
  label: string;
  value: string;
  toCopy: string;
};

export default function CodeContainer(props: PropsType) {
  const { value, toCopy, label } = props;
  return (
    <div className={styles.codeContainer}>
      <label>{label}</label>
      <div className={styles.row}>
        <div className={styles.codeBox}>
          <pre className={styles.code_style}>{value}</pre>
        </div>
        <CopyButton toCopy={toCopy} />
      </div>
    </div>
  );
}
